(ns frontend.test.event
  (:require
   [frontend.test.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::set-selected-test
 (fn [{db :db} [_ selected]]
   {:db (assoc db ::sub/selected-test selected)}))

(rf/reg-event-fx
 ::set-theme
 (fn [{db :db} [_ theme]]
   (let [html (.querySelector js/document "html")]
     (.setAttribute html "data-theme" theme)
     {:db (assoc db ::sub/selected-theme theme)})))

(rf/reg-event-fx
 ::set-minimized?
 (fn [{db :db} [_ v]]
   {:db (assoc db ::sub/minimize? v)}))
